import * as React from 'react';
export const IcEngineeringRequest = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17 13a3.809 3.809 0 00-1 .15L10.85 8c.094-.325.145-.661.15-1a4 4 0 00-4-4h-.21a1 1 0 00-.65 1.7l.86.89L5.59 7l-.87-.86a1 1 0 00-1-.21 1 1 0 00-.72.84A1.79 1.79 0 003 7a4 4 0 004 4 3.808 3.808 0 001-.15L13.15 16a3.809 3.809 0 00-.15 1 4 4 0 104-4zm0 6a2 2 0 110-4 2 2 0 010 4zm0-8a4 4 0 004-4 .998.998 0 000-.2 1 1 0 00-1.7-.66l-.89.86L17 5.59l.86-.87a1 1 0 00.21-1 1 1 0 00-.84-.72H17a4 4 0 100 8zM7 13a4 4 0 00-4 4 .999.999 0 000 .2 1 1 0 001.7.66l.89-.86L7 18.41l-.86.87a1 1 0 00.63 1.67L7 21a4 4 0 100-8z'
      fill='currentColor'
    />
  </svg>
);
